module.exports = [{
      plugin: require('/Users/jdpack/Documents/Plebiant/plebiant-site/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"plebiant","short_name":"Landing","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"standalone","icon":"src/assets/img/website-icon.png"},
    },{
      plugin: require('/Users/jdpack/Documents/Plebiant/plebiant-site/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/jdpack/Documents/Plebiant/plebiant-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
